<template>
    <div class="w-full h-screen flex items-center justify-center">
        <div class="max-w-lg px-4">
<!--          <h1 class="text-4xl md:text-6xl">{{T('contacts')}}</h1>-->
          <div v-html="$store.state.posts.contacts.body[locale()]"></div>
          <p class="mt-4"><a href="mailto:info@yonkovastudio.com">info@yonkovastudio.com</a></p>
          <div class="mt-1">
            <a href="https://www.facebook.com/Iliana-Yonkova-Studio-Ltd-824961560903368/" target="_blank" class="mr-2">
              <img src="/img/fb.svg" style="width: 40px" alt="facebook" class="inline-block opacity-50 hover:opacity-100">
            </a>
            <a href="https://www.instagram.com/ilianayonkovastudio/" target="_blank" class="lg:mr-5 md:mr-2">
              <img src="/img/instagram.svg" style="width: 40px" alt="instagram" class="inline-block opacity-50 hover:opacity-100">
            </a>
          </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'contacts',
        props: {

        },
        data(){
            return{

            }
        },
        mounted() {

        }
    }
</script>
